import React from "react";
import { Link } from "react-router-dom";
import { SITE } from "../../data/site";

export default function CtaBand({
  title = "Ready to start your project?",
  text = "Tell us what you have in mind and we’ll arrange a free, no-obligation visit and quote.",
}) {
  return (
    <section className="bg-ink relative overflow-hidden">
      <div className="grain relative max-w-site mx-auto px-5 sm:px-10 py-16 md:py-20 lg:grid lg:grid-cols-[1.4fr_1fr] lg:items-center gap-12">
        <div>
          <p className="eyebrow eyebrow--light mb-4">Free consultation</p>
          <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.08]">
            {title}
          </h2>
          <p className="text-paper/80 text-lg leading-7 mt-5 max-w-xl">{text}</p>
        </div>
        <div className="mt-8 lg:mt-0 flex flex-col sm:flex-row lg:flex-col gap-4 lg:items-stretch">
          <Link to="/contact" className="btn-primary flex-1">
            Request a quote
          </Link>
          <a href={SITE.phoneHref} className="btn-outline-light flex-1">
            Call {SITE.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
